import React from "react";
import { TextField, Box, Typography } from "@mui/material";

function humanizeLabel(key) {
  if (!key) return "";
  return key
    .toString()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function FieldText({
  name,
  schema = {},
  value,
  onChange,
  errorText,
}) {
  const description = schema.description;

  const handleChange = (e) => {
    const v = e.target.value;
    if (onChange) onChange(v);
  };

  return (
    <Box mb={1} sx={{ maxWidth: 360 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {humanizeLabel(name)}:
        </Typography>
        <TextField
          type="text"
          value={value ?? ""}
          onChange={handleChange}
          size="small"
          variant="outlined"
          error={Boolean(errorText)}
          helperText={errorText || ""}
          FormHelperTextProps={{ sx: { whiteSpace: "pre-line" } }}
          inputProps={{ "aria-label": humanizeLabel(name) }}
        />
      </Box>
    </Box>
  );
}
